import { render, staticRenderFns } from "./CoinBuy.vue?vue&type=template&id=499ae02f&scoped=true&"
import script from "./CoinBuy.vue?vue&type=script&lang=js&"
export * from "./CoinBuy.vue?vue&type=script&lang=js&"
import style0 from "./CoinBuy.vue?vue&type=style&index=0&id=499ae02f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499ae02f",
  null
  
)

export default component.exports